module.exports = __webpack_public_path__ + "img/Block.fd8d6c7f.svg";